import React, { useEffect, useState, useRef } from 'react'
import { useDispatch } from 'react-redux'
import Icon from '~/Common-Objects/UI/Icon'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import * as siteMaster from '../../data/actions/siteActions' //now we can use user actions here

export default function Modal({
    children,
    width = '600px',
    height = undefined,
    noClickAway = false,
    paperClass = '',
    className = '',
    titleStyle = {},
    title = '',
    footer = null,
    backgroundColor = '#EEEEEE',
    opacity = 0.6,
    closeButton = false,

    onCloseButton = () => { },
    closeButtonClass = '',
    blurBg = false,
    hideScroll = false,
    noScroll = false,
    top = false,
    noInnerPaperBorder = false,
    backButton = false,
    backButtonAction = () => { }
}) {
    const dispatch = useDispatch()
    const [isVisible, setIsVisible] = useState(false)
    const pressRef = useRef(null)

    const removeModal = () => {
        if (noClickAway) return
        dispatch(siteMaster.alterFullpage(''))
    }

    useEffect(() => {
        setTimeout(() => setIsVisible(true), 100)
        if (hideScroll) {
            document.body.style.overflowY = 'hidden'
        }
        if (!noClickAway) {
            document.addEventListener(
                'keydown',
                (pressRef.current = (e) => {
                    if (e.key === 'Escape' || e.key === 'Esc') {
                        removeModal()
                    }
                })
            )
        }
        return () => {
            if (pressRef.current) {
                document.removeEventListener('keydown', pressRef.current)
            }
            if (hideScroll) {
                document.body.style.overflowY = 'auto'
            }
        }
    }, [])

    paperClass += ' tpModalPaper mar-b0'
    if (!!title || !!footer) paperClass += ' with_header'

    const modalBgclass = 'tpModalBg' + (blurBg ? ' tpModalBgBlur' : '')
    if (blurBg) {
        backgroundColor = ''
        opacity = ''
    }

    const innerStyle = {}
    const paperStyle = {}
    if (noScroll) {
        //innerStyle.overflow = 'initial'
    }

    let maxHeight = height;
    if (top) {
        maxHeight = "calc(100vh - 140px)" //if top is true, account for the fixed 120px top margin
        innerStyle.maxHeight = "inherit"
        innerStyle.overflow = "auto"
        paperStyle.maxHeight = "inherit"
        paperStyle.overflow = "auto"
    }

    if (noInnerPaperBorder) paperStyle.border = 'none';

    return (
        <div className='tpModalRoot'>
            <div
                className={modalBgclass}
                style={{
                    backgroundColor: backgroundColor,
                    opacity: opacity
                }}
                onClick={removeModal}
            />

            <div
                className={`tpModalPopup ${isVisible ? 'show' : ''} ${top ? 'top' : ''} ${className}`}
                style={{
                    maxWidth: width,
                    maxHeight: maxHeight,
                    height: height,
                }}
            >

                <Paper className={paperClass} style={paperStyle}>
                    <div className='tpModalPaperInner' style={innerStyle}>

                        {backButton && (
                            <div onClick={backButtonAction} className='tpModalBackButton'>
                                <Icons icon='arrowLeftLight' style={{ width: 24, height: 24 }} />
                            </div>
                        )}

                        {closeButton && (
                            <div onClick={onCloseButton} className={'tpModalCloseButton ' + (closeButtonClass || '')}>
                                <Icon name='cross-light' style={{ width: 30, height: 30 }} />
                            </div>
                        )}

                        {!!title && (
                            <div className='paper_header' style={titleStyle}>
                                {title}
                            </div>
                        )}
                        {(!!title || !!footer) && <div className='paper_content'>{children}</div>}
                        {!title && !footer && children}
                        {!!footer && <div className='paper_footer'>{footer}</div>}
                    </div>
                </Paper>
            </div>
        </div>
    )
}
